import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedOrder } from "../types/orderApiTypes";

interface OrderSummaryProps {
  order: TransformedOrder;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ order }) => {
  const { t } = useTranslation();

  return (
    <dl className="order-page__summary">
      <div className="order-page__summary-item">
        <dt>{t("orderPage.summary.orderNumber", "Order Number")}</dt>
        <dd>#{order.orderNumber}</dd>
      </div>
      <div className="order-page__summary-item">
        <dt>{t("orderPage.summary.date", "Date")}</dt>
        <dd>{order.dateCreated}</dd>
      </div>
      <div className="order-page__summary-item">
        <dt>{t("orderPage.summary.paymentMethod", "Payment Method")}</dt>
        <dd>{order.paymentMethodInfo.title}</dd>
      </div>
      <div className="order-page__summary-item">
        <dt>{t("orderPage.summary.total", "Total")}</dt>
        <dd>{order.totals.totalPrice}</dd>
      </div>
    </dl>
  );
};

export default OrderSummary;
